import { render, staticRenderFns } from "./CampaignSettings.vue?vue&type=template&id=4270cfda&scoped=true&"
import script from "./CampaignSettings.vue?vue&type=script&lang=ts&"
export * from "./CampaignSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSettings.vue?vue&type=style&index=0&id=4270cfda&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270cfda",
  null
  
)

export default component.exports